import { Stack, Image, PrimaryButton, FontIcon, TextField, DefaultButton, Dialog, DialogType, Label } from '@fluentui/react';
import React, { FormEvent, useContext, useEffect, useState } from 'react';
import styles from '../styles/pokemon.module.scss';
import { TSale, TShoppingCart } from '../constants/types';
import Globals, { GetAdress, IsNull } from '../services/Globals';
import { CalculatePrices } from '../helpers/General';
import GlobalContext from '../_contexts/GlobalContext';

export interface IcheckoutComponentProps {
    satprice: number;
    shoppingcart: TShoppingCart;
    onCheckOut: Function;
    onCheckOutIDeal: Function;
    onCancel: Function;
    ShowMessage: Function;
    debug: boolean;
    eurprice: number;
    usdprice: number;
}
 
const CheckoutComponent : React.FunctionComponent<IcheckoutComponentProps> = (props : IcheckoutComponentProps) => {
    const [postalCode, setpostalCode] = useState<string>();
    const [homeNumber, sethomeNumber] = useState<string>();
    const [street, setstreet] = useState<string>();
    const [city, setcity] = useState<string>();
    const [checkoutDisabled, setcheckoutDisabled] = useState<boolean>(false);
    const [sendCost, setsendCost] = useState<number>(0);
    const [totalCost, settotalCost] = useState<number>(0);
    const [mail, setmail] = useState<string>();
    const [mail2, setmail2] = useState<string>();
    const [name, setname] = useState<string>();
    const [addition, setaddition] = useState<string>();
    const [popupUrl, setpopupUrl] = useState<string>();

    const { DebugEnabled, BitcoinEnabled, Strings } = useContext(GlobalContext);

    useEffect(() => {
        if (DebugEnabled) {
            setmail("pokemoncollectie@outlook.com");
            setmail2("pokemoncollectie@outlook.com");
            setname("Pietje Puk");
            setpostalCode("1122AB");
            setstreet("Kerkstraat");
            sethomeNumber("69420");
            setcity("Schrubbekutteveen");
            setcheckoutDisabled(false);
            setsendCost(0);
            settotalCost(0);
        }

        const [total,sendcost] = CalculatePrices(props.satprice, props.eurprice, props.usdprice, props.shoppingcart, BitcoinEnabled);
        setsendCost(sendcost);
        settotalCost(total);
    },[])

    function getAdress(postalCode:string, homeNumber:string) {
        if (postalCode && homeNumber) {
            GetAdress(postalCode, homeNumber).then(data => {
                if (data.response.numFound >= 1) {
                    setstreet(data.response.docs[0].straatnaam);
                    setcity(data.response.docs[0].woonplaatsnaam);
                }
            });
        }
    }

    function onPostalCodeChange(event: FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string | undefined) {
        const _postalCode = newValue?.replace(/\s/g, "");
        setpostalCode(_postalCode);
        if (homeNumber !== undefined && _postalCode !== undefined) {
            getAdress(_postalCode, homeNumber);
        }
    }

    function onHomeNumberChange(event: FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string | undefined) {
        sethomeNumber(newValue);
        if (postalCode !== undefined && newValue !== undefined) {
            getAdress(postalCode, newValue);
        }
    }

    function onNameChange(event: FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string | undefined) {
        setname(newValue);
    }

    function onaAdditionChange(event: FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string | undefined) {
        setaddition(newValue);
        if (homeNumber !== undefined && postalCode !== undefined && city === undefined) {
            getAdress(postalCode, homeNumber);
        }
    }

    function onMailChange(event: FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string | undefined) {
        let reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
        if (newValue && reg.test(newValue) === true) 
        {
            setmail(newValue);
        }
    }

    function onMail2Change(event: FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string | undefined) {
        let reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
        if (newValue && reg.test(newValue) == true) 
        {
            setmail2(newValue);
        }
    }

    function validation() : boolean {
        let rtnVal = true;
        let reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
        if (!mail || reg.test(mail) === false) {
            props.ShowMessage("Vul aub een geldig email adres in", 2000);
            rtnVal = false;
        }
        if (mail?.toLocaleLowerCase() != mail2?.toLocaleLowerCase()) {
            props.ShowMessage("De ingevulde email adressen zijn niet gelijk", 2000);
            rtnVal = false;
        }
        reg = /^[a-z ,.'-]+$/i;
        if (!name || reg.test(name) === false) {
            props.ShowMessage("Vul aub een geldige naam in", 2000);
            rtnVal = false;
        }
        reg = /^[1-9][0-9]{3} ?(?!sa|sd|ss)[a-z]{2}$/i;
        if (!postalCode || reg.test(postalCode) === false) {
            props.ShowMessage("Vul aub een geldige postcode in", 2000);
            rtnVal = false;
        }
        //reg = /^[A-Za-z]$/i;
        if (!street) { 
            props.ShowMessage("Vul aub een geldige straatnaam in", 2000);
            rtnVal = false;
        }
        reg = /^\d+$/;
        if (!homeNumber || reg.test(homeNumber) === false) {
            props.ShowMessage("Vul aub een geldig huisnummer in", 2000);
            rtnVal = false;
        }
        //reg = /^[1-9][0-9]{6}$/i;
        if (!city) { 
            props.ShowMessage("Vul aub een geldige plaatsnaam in", 2000);
            rtnVal = false;
        }
        return rtnVal;
    }

    function onCheckOut() {
        if (validation()) {
            setcheckoutDisabled(true);
            let _homeNumber = homeNumber?.toString();
            if (!IsNull(addition)) {
                _homeNumber += " "+ addition;
            }
            props.onCheckOut({ email: mail2, name: name, postalCode: postalCode, street: street, number: homeNumber, city: city })
        } else {
            
        }
    }

    function onCheckOutIDeal() {
        if (validation()) {
            setcheckoutDisabled(true);
            let _homeNumber = homeNumber?.toString();
            if (!IsNull(addition)) {
                _homeNumber += " "+addition;
            }
            props.onCheckOutIDeal({ email: mail2, name: name, postalCode: postalCode, street: street, number: _homeNumber, city: city });
        } else {
            
        }
    }

    return (   
        <Stack className={styles.preCheckOutMain} tokens={{ maxWidth: 320}}>
            <Dialog
                hidden={!popupUrl}
                dialogContentProps={{type:DialogType.normal}}
                onDismiss={() => { setpopupUrl(undefined); }}
                modalProps={{styles: {main : { maxHeight: "100%!important", width: 800, height: 800, maxWidth: "95%!important", backgroundColor: "transparent", boxShadow: "none", overflowY:"hidden"}}}}
            >
                <Image className={styles.popupImage} onClick={() => { setpopupUrl(undefined); }} src={popupUrl} alt="" /> 
            </Dialog>
            <Stack horizontal tokens={{ childrenGap: 20, padding: 2 }}>
                <Label>{Strings.CheckOutMainText}</Label>
            </Stack>
            <hr style={{width: "100%"}} />
            <Stack horizontal tokens={{ childrenGap: 20, padding: 2 }}>
                <TextField inputMode='email' name="email" type={"email"} className={styles.checkoutName} label={"Email *"} placeholder={"voorbeeld@mail.com"} onChange={onMailChange} />
            </Stack>
            <Stack horizontal tokens={{ childrenGap: 20, padding: 2 }}>
                <TextField inputMode='email' name="email" type={"email"} className={styles.checkoutName} label={`${Strings.ReAddEmail} *`} placeholder={"voorbeeld@mail.com"} onChange={onMail2Change} />
            </Stack>
            <Stack horizontal tokens={{ childrenGap: 20, padding: 2 }}>
                <TextField type="name" name="name" className={styles.checkoutName} label={`${Strings.RecipientName} *`} placeholder={Strings.FullName} onChange={onNameChange} />
            </Stack>
            <Stack horizontal tokens={{ childrenGap: 20, padding: 2 }}>
                <TextField type="postalcode" name="postalcode" label={`${Strings.Postalcode} *`} placeholder={"1122XY"} maxLength={6} onChange={onPostalCodeChange} />
                <TextField type="homenumber" name="homenumber" className={styles.checkoutNumber} label={`${Strings.Number} *`} placeholder={"1"} onChange={onHomeNumberChange} />
                <TextField type="" className={styles.chechoutToevoeging} label={`${Strings.Addition}`} placeholder={""} onChange={onaAdditionChange} />
            </Stack>
            <Stack horizontal tokens={{ childrenGap: 20, padding: 2 }}>
                <TextField label={`${Strings.Street} *`} placeholder={""} value={street} onChange={(event: FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string | undefined) => { setstreet(newValue); }}/>
                <TextField label={`${Strings.City} *`} placeholder={""} value={city} onChange={(event: FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string | undefined) => { setcity(newValue); }}/>
            </Stack>
            <hr style={{width: "100%"}} />
            <Stack horizontal tokens={{ childrenGap: 3, padding: 1 }}>
                <div className={styles.checkoutCardMain}>
                    {props.shoppingcart.items.map(item => {
                        if (item.product.imageUrls.length > 0) {
                            return <div className={styles.checkoutCardWrapper}>
                                        <Stack horizontal verticalAlign='center'>
                                            {`${item.ammount}x`}
                                            <img onClick={() => { setpopupUrl(item.product.imageUrls[0]); }} className={styles.checkoutCardImg} src={item.product.imageUrls[0]} alt="" />
                                        </Stack>
                                    </div>;
                        }
                    })}
                </div>
            </Stack>
            <hr style={{width: "100%"}} />
            {BitcoinEnabled &&  <Stack horizontal horizontalAlign='space-between'>
                <Label>{Strings.SendingCost}</Label>
                <Stack horizontal>
                    <Image className={styles.btciconsmallcard}
                        style={{ cursor: "default", paddingTop:2 }}
                        src={`${process.env.PUBLIC_URL}/assets/btcicon.png`}
                    />
                    <Label>{sendCost} sats</Label>
                </Stack>
            </Stack>}
            {BitcoinEnabled && <Stack horizontal horizontalAlign='space-between'>
                <Label>{Strings.Subtotal}</Label>
                  <Stack horizontal>
                        <Image className={styles.btciconsmallcard}
                            style={{ cursor: "default", paddingTop:2 }}
                            src={`${process.env.PUBLIC_URL}/assets/btcicon.png`}
                        />
                        <Label><b>{totalCost} sats</b></Label>
                    </Stack>
            </Stack>}
            <Stack horizontal horizontalAlign='space-between'>
                <Label>{Strings.Subtotal}</Label>
                {BitcoinEnabled ? <Label style={{fontSize:"smaller"}}>€ {(Math.round(100 * totalCost * props.satprice * props.eurprice) / 100).toFixed(2)}</Label>
                                : <Label style={{fontSize:"smaller"}}>€ {(totalCost-sendCost).toFixed(2)}</Label>}
            </Stack>
            {BitcoinEnabled && <>
                                <Label className={styles.priceWarning}>* {Strings.PaymentNote}</Label>
                                <hr style={{width: "100%"}} />
                                <Stack horizontal tokens={{ childrenGap: 20, padding: 2 }}>
                                    <PrimaryButton disabled={checkoutDisabled} className={styles.checkoutButton} text={Strings.CheckOutWithBitcoin} onClick={() => { onCheckOut();}}>
                                        <FontIcon aria-label="Afrekenen" iconName="LightningBolt" />
                                    </PrimaryButton> 
                                </Stack></>}
            <hr style={{width: "100%"}} />
            <Stack horizontal horizontalAlign='space-between'>
                <Label>{Strings.SendingCost}</Label>
                {BitcoinEnabled ? <Label style={{fontSize:"smaller"}}>€ {(Math.round(sendCost * props.satprice * 100 * props.eurprice) / 100).toFixed(2)}</Label>
                                : <Label style={{fontSize:"smaller"}}>€ {sendCost.toFixed(2)}</Label>}
            </Stack>
            <Stack horizontal horizontalAlign='space-between'>
                <Label>{Strings.IDealCost}</Label>
                <Label>€ 0.40</Label>
            </Stack>
            <Stack horizontal horizontalAlign='space-between'>
                <Label>{Strings.Total}</Label>
                {BitcoinEnabled ? <Label><b>€ {(((((totalCost * props.satprice) * props.eurprice)+0.40) * 100) / 100).toFixed(2)}</b></Label>
                                : <Label><b>€ {(totalCost+0.40).toFixed(2)}</b></Label>}
            </Stack>
            <hr style={{width: "100%"}} />
            <Stack horizontal horizontalAlign='end' tokens={{ childrenGap: 20, padding: 2 }}>
                <PrimaryButton disabled={checkoutDisabled} className={styles.checkoutButton} text={Strings.CheckOutWithIDeal} onClick={() => { onCheckOutIDeal();}}>
                    <Image style={{maxHeight: 20, cursor: "pointer", backgroundColor: "white", borderRadius: "5px", padding: 2, margin: 2}} src={`${process.env.PUBLIC_URL}/assets/idealicon.webp`} />
                </PrimaryButton> 
            </Stack>
            <hr style={{width: "100%"}} />
            <Stack horizontal horizontalAlign='start' tokens={{ childrenGap: 20, padding: 2 }}>
                <DefaultButton className={styles.checkoutButton} text={Strings.KeepShopping} onClick={() => {props.onCancel();}} />
            </Stack>
        </Stack>
    );
}

export default CheckoutComponent;